import RetoolComp from "./retool_components/retool";

export const SupplyApproval = () => {
    const deal_uuid = "06a47310-8011-11ee-9a83-eba8caa67ba6";
    return <RetoolComp component_uuid={deal_uuid} />;
};
